import ApiJiraIntegration from "../api/model/integrations/barrel/JiraIntegration";
import JiraAttachment from "./JiraAttachment";
import Model from "./model";

class JiraIntegration extends Model {
    id: string;
    _id: string;
    attachments?: JiraAttachment[];

    constructor(data: ApiJiraIntegration) {
        super();

        const { _id, attachments } = data;

        this.id = _id;
        this._id = _id;

        if (attachments) {
            this.attachments = attachments.map(attachment => new JiraAttachment(attachment));
        }
    }
}

export default JiraIntegration;
